<template>
  <div>
    <h4 class="mb-4"><strong>El número no posee plan</strong></h4>
    <p></p>

    <a href="https://mivirgin.virginmobile.cl/planes" class="btn btn-primary" type="button">
      Ir a Planes
    </a>

  </div>
</template>

<script>
export default {
  name: 'PaymentTariffUnknown',

  setup() {
    return {
      error: {
        msisdn: false
      },
      msisdn: '',
    }
  },
}
</script>

<style scoped>
</style>
